import { NewsboardList, NewsboardPost } from '../../Newsboard'
import { PostListNoData } from '../PostListNoData'

function PostList(props) {
  const {
    emptyStateActions,
    getShowEmptyListRules,
    getThresholdItemProps,
    items,
    loading,
  } = props

  const showEmptyList = getShowEmptyListRules(items, loading)

  return showEmptyList ? (
    <PostListNoData actions={emptyStateActions} />
  ) : (
    <NewsboardList>
      {!loading && items?.length === 0 ? (
        <PostListNoData actions={emptyStateActions} />
      ) : null}
      {items?.map((item, index) => (
        <NewsboardPost
          {...getThresholdItemProps(index)}
          key={index}
          value={item}
          onHideWelcomePost={props.onHideWelcomePost}
          onReload={props.onReload}
        />
      ))}
      {loading ? <NewsboardPost loading={loading} /> : null}
    </NewsboardList>
  )
}

export default PostList
